export default "__VITE_ASSET__C$6rZ2Te__"